import { cn } from "@homeinstead/ui";

function getInquiryStepClassName(activeStep: number, step: number) {
  return cn(
    "w-full flex-col transition-opacity duration-300 [grid-area:1/1]",
    activeStep === step
      ? "z-10 flex opacity-100"
      : "pointer-events-none invisible z-0 flex opacity-0",
  );
}

export { getInquiryStepClassName };
